import { ALERT_ERRORS } from 'src/app/core/constants/Errors';
import { GENERAL_CONSTANTS } from 'src/app/core/constants/General-constants';
import { AlertService } from 'src/app/services/alert.service';

// Create an instance of the alert service
export const alertService = new AlertService();

/**
 *
 * @description validateUserDevice Function to detect if the user is using a mobile device
 * @returns response
 */
export function validateUserDevice() {
    let response = false;

    for (const device of Object.values(GENERAL_CONSTANTS.MOBILE_DEVICES)) {
        if (navigator.userAgent.match(device) || window.innerWidth <= GENERAL_CONSTANTS.SCREEN_SIZE_MOBILE_DEVICE) {
            response = true;
        }
    }

    return response;
}

/**
 *
 * @description getUrlReturnMerchant Function to return the URL to redirect the user after the payment process
 * @returns response
 */
export function createMerchantReturnUrl(orderID: string, returnUrl: string) {
    try {
        if (!returnUrl) throw new Error(ALERT_ERRORS.RETURN_URL_INVALID);

        if (!orderID) return returnUrl;

        const newUrl = new URL(returnUrl);
        const params = new URLSearchParams(newUrl.search);

        params.append('order', orderID);

        return `${newUrl.origin}${newUrl.pathname}?${params.toString()}`;
    } catch (e) {
        console.error(e);
        return '';
    }
}

/**
* Converts an image URL to a base64 encoded string.
* @param {string} url - The URL of the image to convert.
* @return {Promise<string>} A promise that resolves with the base64 encoded string of the image.
*/
export function convertImageToBase64(url: string) {
    return new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest();
        xhr.onload = function () {
            let reader = new FileReader();
            reader.onloadend = function () {
                resolve(reader.result);
            };
            reader.onerror = reject;
            reader.readAsDataURL(xhr.response);
        };
        xhr.onerror = function () {
            reject(new Error('Error loading image'));
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    });
}

/**
 * Function to wait for a specified amount of time
 * @param minutes - The amount of time to wait in minutes
 * @returns A promise that resolves after the specified amount of time
 * @example
 * await sleep(5); // waits for 5 minutes
 * @example
 * sleep(5).then(() => console.log('done')); // waits for 5 minutes
*/
export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));


/**
 * Function to create a countdown timer
 * @param duration - The amount of time to count down in seconds
 * @param display - The element to display the countdown in
 * @example
 * countdown(60, (timeString) => console.log(timeString)); // logs the time remaining every second
*/
export function countdown(duration: any, timeString: (timeString: string) => void) {
    let timer = duration, minutes: string | number, seconds: string | number;
    const interval = setInterval(() => {
        minutes = Math.floor(timer / 60);
        seconds = timer % 60;

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        timeString(minutes + ":" + seconds);

        if (--timer < 0) {
            clearInterval(interval);
        }
    }, 1000);
}

